import { Link, useLocation } from 'react-router-dom';

const PaymentCancel = () => {
  const location = useLocation();
  const orderId = location.state?.orderId;
  
  return (
    <div className="max-w-2xl mx-auto">
      <div className="neumorph p-8 rounded-lg text-center">
        <div className="mb-6">
          <div className="neumorph inline-flex items-center justify-center p-4 rounded-full bg-red-100 text-red-600">
            <svg className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Payment Cancelled</h1>
        
        <p className="text-gray-600 mb-6">
          Your payment was cancelled or did not complete successfully. No charges have been made to your account.
        </p>
        
        {orderId && (
          <div className="neumorph-inset p-4 rounded-lg mb-6">
            <p className="text-gray-600">Order ID: {orderId}</p>
          </div>
        )}
        
        <p className="text-gray-600 mb-6">
          If you encountered any issues during the payment process, please try again or contact our support team for assistance.
        </p>
        
        <div className="flex justify-center space-x-4">
          <Link to="/cart" className="neumorph-btn px-6 py-3">
            Return to Cart
          </Link>
          <Link to="/products" className="neumorph-btn px-6 py-3">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
